import ViewItemAdjustment from "../../../../components/@documents/item_adjustments/ViewItemAdjustment";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentViewPage() {

    return (
        <ViewItemAdjustment 
            routeType={routeTypes.admin}
        />
    )
}